export var getPromotedByString = function(promotedBy) {
    var _promotedBy_join;
    return (_promotedBy_join = promotedBy === null || promotedBy === void 0 ? void 0 : promotedBy.join(" ")) !== null && _promotedBy_join !== void 0 ? _promotedBy_join : "";
};
